module.exports = __webpack_public_path__ + "static/media/weatherdashboardimage.7a09653c.jpg";